import React, {useEffect, useState} from 'react';

import { connect } from 'react-redux';

import { isEmpty } from 'lodash';

import {
    Chart,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartTooltip,
    ChartCategoryAxisItem,
    ChartValueAxisItem,
    ChartValueAxis
} from '@progress/kendo-react-charts';

import * as classes from './ExecutiveSummaryScoreGuage.module.css';

const ExecutiveSummaryFaultsByPriority = ({
    bobLoading,
    extendedColumns,
    faultFilters,
    faults,
    faultsMeta,
    setFaultFilters,
    ...props
}) => {
    const [high, setHigh] = useState([]);
    const [medium, setMedium] = useState([]);
    const [low, setLow] = useState([]);

    useEffect(() => {
        let highFault = [];
        let mediumFault = [];
        let lowFault = [];

        faults.forEach(item => {
            const local = new Date(item.faultDate);

            highFault.push({ value: item.highFaultCount, date: new Date(local.getTime() + local.getTimezoneOffset() * 60000)});
            mediumFault.push({ value: item.mediumFaultCount, date: new Date(local.getTime() + local.getTimezoneOffset() * 60000)});
            lowFault.push({ value: item.lowFaultCount, date: new Date(local.getTime() + local.getTimezoneOffset() * 60000)});
        });

        setHigh(highFault);
        setMedium(mediumFault);
        setLow(lowFault);
    }, [faults]);

    const SharedTooltip = (props) => {
        const { category, points } = props;

        const renderName = point => {
            if (point.series.toField === 'low') {
                return 'Low';
            } else if (point.series.toField === 'medium') {
                return 'Medium';
            } else if (point.series.toField === 'high') {
                return 'High';
            }
        };

        return (
            <div>
                <div>{category}</div>
                {points.map((point, i) => (
                    <div key={i}>
                        {renderName(point)} : {point.value}
                    </div>
                ))}
            </div>
        );
    };

    const sharedTooltipRender = (context) => <SharedTooltip {...context} />;

    const renderColumns = () => {
        let columns = [];

        if (faultFilters.includes('low')) {
            columns.push({
                color: '#f1c21b',
                data:  low,
                index: 'low'
            });
        }

        if (faultFilters.includes('medium')) {
            columns.push({
                color: '#ff832c',
                data:  medium,
                index: 'medium'
            });
        }

        if (faultFilters.includes('high')) {
            columns.push({
                color: '#da1d28',
                data:  high,
                index: 'high'
            });
        }

        return columns;
    };

    const handleFilter = filter => {
        let updatedFilters = [...faultFilters];

        if (updatedFilters.includes(filter)) {
            const index = updatedFilters.findIndex(item => item === filter);
            updatedFilters.splice(index, 1);
            setFaultFilters(updatedFilters);
        } else {
            updatedFilters.push(filter);
            setFaultFilters(updatedFilters);
        }
    };

    return (
        <React.Fragment>
            {isEmpty(faultsMeta) || bobLoading.includes('FetchExecutiveSummaryFaults') ?
                <div className={classes.Loader}>
                    <img src="/assets/images/BobLoaderLarge.gif" alt="loader" />
                </div>
                :
                <React.Fragment>
                    <Chart
                        style={{
                            height: extendedColumns ? 750 : 325,
                            width:  extendedColumns ? 800 : 'auto'
                        }}
                    >
                        <ChartTooltip shared={true} render={sharedTooltipRender} />
                        <ChartValueAxis>
                            <ChartValueAxisItem
                                min={0}
                            />
                        </ChartValueAxis>
                        <ChartCategoryAxis>
                            <ChartCategoryAxisItem />
                        </ChartCategoryAxis>
                        <ChartSeries>
                            {
                                renderColumns().map((column, index) => (
                                    <ChartSeriesItem
                                        key={index}
                                        toField={column.index}
                                        stack={true}
                                        color={column.color}
                                        field="value"
                                        categoryField="date"
                                        type="column"
                                        data={column.data}
                                    />
                                ))
                            }
                        </ChartSeries>
                    </Chart>
                    <div style={{ textAlign: 'center' }}>
                        <span role="none" onClick={() => handleFilter('high')}>
                            <img className={classes.IconImage} src={faultFilters.includes('high') ? '/assets/images/high.svg' : '/assets/images/grayHigh.svg'} alt="" />
                            <span className={classes.FaultLabel}>High</span>
                        </span>
                        <span role="none" onClick={() => handleFilter('medium')}>
                            <img className={classes.IconImage} src={faultFilters.includes('medium') ? '/assets/images/medium.svg' : '/assets/images/grayMedium.svg'} alt="" />
                            <span className={classes.FaultLabel}>Medium</span>
                        </span>
                        <span role="none" onClick={() => handleFilter('low')}>
                            <img className={classes.IconImage} src={faultFilters.includes('low') ? '/assets/images/low.svg' : '/assets/images/grayLow.svg'} alt="" />
                            <span className={classes.FaultLabel}>Low</span>
                        </span>
                    </div>
                </React.Fragment>
            }
        </React.Fragment>
    );
};

const mapStateToProps = state => {
    return {
        bobLoading: state.bob.bobLoading,
        faults:     state.executiveSummary.faults,
        faultsMeta: state.executiveSummary.faultsMeta
    };
};


export default connect(mapStateToProps, null)(ExecutiveSummaryFaultsByPriority);
